import _get from 'lodash/get'
import _set from 'lodash/set'
import React from 'react'
import { withFormik } from 'formik'
import Modal from 'react-modal'

import modalStyle from '../../../_common/core/modalStyle'
import Button from '../../_library/Button'
import TextArea from '../../_library/TextArea'
import Field from '../../_library/Field'

import EventBrandLevelFBPixel from './EventBrandLevelFBPixel'
import FaceBookPixels from '../../_features/facebookPixel'

const rgx = /'init','(.*)'\);fbq/g
const normalize = /[\s|\n]+/g

function validate(data, brandPixelData) {
  const gaIdRegexp = /^ua-\d{4,9}-\d{1,4}$/i
  const ga4IdRegexp = /^g-[A-Za-z0-9]{4,}$/i
  const gtmRegex = /^gtm-[A-Z0-9]{4,9}$|^aw-[A-Z0-9]{4,}$/i
  const errors = {}

  const pagePixels = _get(data, 'pagePixels')
  const checkoutPixels = _get(data, 'checkoutPixels')
  const conversionPixels = _get(data, 'conversionPixels')
  const googleAnalyticsKey = _get(data, 'googleAnalyticsKey')
  const googleAnalyticsMeasurementId = _get(data, 'googleAnalyticsMeasurementId')
  const googleTagManagerKey = _get(data, 'googleTagManagerKey')

  if (
    brandPixelData &&
    brandPixelData.pagePixels &&
    checkDuplicateFBPixel(pagePixels, brandPixelData.pagePixels)
  ) {
    _set(errors, 'pagePixels', 'This code is already imported at Brand level')
  }
  if (
    brandPixelData &&
    brandPixelData.checkoutPixels &&
    checkDuplicateFBPixel(checkoutPixels, brandPixelData.checkoutPixels)
  ) {
    _set(errors, 'checkoutPixels', 'This code is already imported at Brand level')
  }
  if (
    brandPixelData &&
    brandPixelData.conversionPixels &&
    checkDuplicateFBPixel(conversionPixels, brandPixelData.conversionPixels)
  ) {
    _set(errors, 'conversionPixels', 'This code is already imported at Brand level')
  }

  if (!!googleAnalyticsKey && !gaIdRegexp.test(googleAnalyticsKey.toString())) {
    _set(errors, 'googleAnalyticsKey', 'Invalid Tracking ID')
  } else if (!!googleAnalyticsKey && googleAnalyticsKey === brandPixelData.googleAnalyticsKey) {
    _set(errors, 'googleAnalyticsKey', 'This tracking ID is already imported at Brand level')
  }

  if (!!googleAnalyticsMeasurementId && !ga4IdRegexp.test(googleAnalyticsMeasurementId.toString())) {
    _set(errors, 'googleAnalyticsMeasurementId', 'Invalid Measurement ID')
  } else if (
    !!googleAnalyticsMeasurementId &&
    googleAnalyticsMeasurementId === brandPixelData.googleAnalyticsMeasurementId
  ) {
    _set(errors, 'googleAnalyticsMeasurementId', 'This measurement ID is already imported at Brand level')
  }

  if (!!googleTagManagerKey && !gtmRegex.test(googleTagManagerKey.toString())) {
    _set(errors, 'googleTagManagerKey', 'Invalid ID')
  }

  return errors
}

function checkDuplicateFBPixel(eventPixel, brandPixel) {
  rgx.lastIndex = 0
  const eventPixelId = rgx.exec(eventPixel.replace(normalize, ''))
  rgx.lastIndex = 0
  const brandPixelId = rgx.exec(brandPixel.replace(normalize, ''))
  return !!(eventPixelId && brandPixelId && eventPixelId[1] === brandPixelId[1])
}

class MyForm extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      showBrandFbPixelDialog: false,
      showGoogleTagManager: true, //this.props.dynamicConfigs.get('google_tag_manager', false)
    }
  }

  updateField = (field, value) => {
    const { setFieldValue } = this.props
    setFieldValue(field, value)

    const fieldName = `attributes.${field}`
    const fields = form_helper_get()
    fields[fieldName] = fieldName
    form_helper_set(fields)
  }

  handleChangeTextArea = (field, event) => {
    this.updateField(field, event.target.value)
  }

  openBrandFbPixelDialog = () => {
    this.setState({ showBrandFbPixelDialog: true })
  }

  closeBrandFbPixelDialog = () => {
    this.setState({ showBrandFbPixelDialog: false })
  }

  render() {
    const { submitLabel, brandPixelData } = this.props
    const { showGoogleTagManager } = this.state
    const showBrandModal =
      brandPixelData &&
      (brandPixelData.pagePixels || brandPixelData.checkoutPixels || brandPixelData.conversionPixels)
    const { values, touched, errors, isSubmitting, handleSubmit } = this.props

    return (
      <form ref="form" method="POST" onSubmit={handleSubmit} className="event-ticket-advanced-options">
        <FaceBookPixels values={values} updateField={this.updateField} submitForm={handleSubmit} />
        {showBrandModal && (
          <div className="row brand-pixel-indicator-holder">
            <div className="col-xs-12">
              <div className="brand-pixel-indicator">
                <i className="fa fa-info-circle" aria-hidden="true" />
                <span className="junior_text">Conversion Tracking Code is Imported at Brand Level</span>
                <button
                  className="btn btn-success"
                  style={{ float: 'right' }}
                  type="button"
                  onClick={this.openBrandFbPixelDialog}
                >
                  View Brand Facebook Pixel
                </button>
              </div>
            </div>
          </div>
        )}
        <br />
        <div className="row">
          <div className="col-xs-12">
            <TextArea
              rows="5"
              id="pagePixels"
              label="View of Event Page"
              value={values.pagePixels}
              error={errors.pagePixels}
              touched={touched.pagePixels}
              onChange={e => this.handleChangeTextArea('pagePixels', e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <TextArea
              rows="5"
              id="checkoutPixels"
              label="Start of Checkout"
              value={values.checkoutPixels}
              error={errors.checkoutPixels}
              touched={touched.checkoutPixels}
              onChange={e => this.handleChangeTextArea('checkoutPixels', e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <TextArea
              rows="5"
              id="conversionPixels"
              label="Completion of Purchase (use {CURRENCY} and {VALUE} to auto-insert conversion data)"
              value={values.conversionPixels}
              error={errors.conversionPixels}
              touched={touched.conversionPixels}
              onChange={e => this.handleChangeTextArea('conversionPixels', e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Field
              className="ga-field"
              id="googleAnalyticsKey"
              label="Google Analytics Tracking ID"
              value={values.googleAnalyticsKey}
              error={errors.googleAnalyticsKey}
              touched={touched.googleAnalyticsKey}
              placeholder="UA-XXXXX-Y"
              onChange={e => this.handleChangeTextArea('googleAnalyticsKey', e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Field
              className="ga-field"
              id="googleAnalyticsMeasurementId"
              label="Google Analytics Measurement ID"
              value={values.googleAnalyticsMeasurementId}
              error={errors.googleAnalyticsMeasurementId}
              touched={touched.googleAnalyticsMeasurementId}
              placeholder="G-XXXXX"
              onChange={e => this.handleChangeTextArea('googleAnalyticsMeasurementId', e)}
            />
          </div>
        </div>
        {showGoogleTagManager && (
          <div className="row">
            <div className="col-xs-12">
              <Field
                className="ga-field"
                id="googleTagManagerKey"
                label="Google Tag Manager Container ID"
                value={values.googleTagManagerKey}
                error={errors.googleTagManagerKey}
                touched={touched.googleTagManagerKey}
                placeholder="GTM-XXXX"
                onChange={e => this.handleChangeTextArea('googleTagManagerKey', e)}
              />
            </div>
          </div>
        )}
        {values.hiveAccountId && (
          <>
            <br />
            <div className="row">
              <div className="col-xs-12">
                <Field
                  className="ga-field"
                  id="hiveSegment"
                  label="Hive Segment for this event"
                  value={values.hiveSegment}
                  error={errors.hiveSegment}
                  touched={touched.hiveSegment}
                  placeholder=""
                  onChange={e => this.handleChangeTextArea('hiveSegment', e)}
                />
              </div>
            </div>
          </>
        )}
        <div className="row">
          <div className="col-xs-12 text-center">
            <Button className="btn btn-success btn-lg btn-shadow" type="submit" loading={isSubmitting}>
              {submitLabel || 'Save Advanced Options'}
            </Button>
          </div>
        </div>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={!!this.state.showBrandFbPixelDialog}
          contentLabel="Modal"
          onRequestClose={this.closeBrandFbPixelDialog}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Brand Facebook Pixel</p>
                </div>
                <div className="modal-body">
                  <EventBrandLevelFBPixel values={brandPixelData ? brandPixelData : null} />
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    <Button
                      className="btn btn-default btn-shadow"
                      type="button"
                      onClick={this.closeBrandFbPixelDialog}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    )
  }
}

const TicketAdvancedOptionsForm = withFormik({
  mapPropsToValues: props => ({
    pagePixels: _get(props, 'initialValues.pagePixels') || '',
    checkoutPixels: _get(props, 'initialValues.checkoutPixels') || '',
    conversionPixels: _get(props, 'initialValues.conversionPixels') || '',
    googleAnalyticsKey: _get(props, 'initialValues.googleAnalyticsKey') || '',
    googleTagManagerKey: _get(props, 'initialValues.googleTagManagerKey') || '',
    hiveAccountId: _get(props, 'initialValues.hiveAccountId') || '',
    hiveSegment: _get(props, 'initialValues.hiveSegment') || '',
    googleAnalyticsMeasurementId: _get(props, 'initialValues.googleAnalyticsMeasurementId') || '',
    venue: _get(props, 'initialValues.venue'),
    pixels: _get(props, 'initialValues.pixels') || [],
  }),

  // Custom sync validation
  validate: (values, props) => {
    const { brandPixelData } = props
    return validate(values, brandPixelData)
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    props
      .onSubmit({
        attributes: {
          ...values,
          endDate: props.initialValues.endDate,
          startDate: props.initialValues.startDate,
          salesEndDate: props.initialValues.salesEndDate,
        },
      })
      .then(v => {
        setSubmitting(false)
      })
      .catch(err => {
        setSubmitting(false)
      })
  },
  displayName: 'TicketAdvancedOptionsForm', // helps with React DevTools
})(MyForm)

export default TicketAdvancedOptionsForm
